import { useTypedSelector } from "@/redux/helpers/hooks.ts";

const useCurrency = () => {
  const siteVersion = useTypedSelector((state) => state.store.site_version);
  const currency = siteVersion.currency;
  const loading = siteVersion.loading;

  if (loading) return "";

  switch (currency.toLowerCase()) {
    case "gbp":
      return "£";
    case "usd":
      return "$";
    default:
      return "£";
  }
};

export default useCurrency;
